export default {
    InternalRefundOrderDetailsOnly: {
        Refund: 'Refund order details',
        Refresh: 'Refresh',
        Approved: 'Approved',
        Approval: 'Rejected',
        Rejected: 'Rejected',
        Reason: 'Reason:',
        Reviewed: 'Reviewer',
        Approvaltime: 'Review time',
        Canceled: 'Canceled',
        Exception: 'Transfer exception',
        Basic: 'Account Information',
        Basicc: 'Can only be modified when pending review',
        Modify: 'Modify',
        Refundnote: 'Refund order type',
        Store: 'Store',
        Refundtype: 'Refund type',
        Refundreason: 'Refund reason',
        Refundstage: 'Refund stage',
        Refundremarks: 'Refund Remarks',
        Customer: 'Customer service Remarks',
        information: 'Buyer information',
        nickname: 'Buyer nickname',
        Refundby: 'Refunder',
        Mobile: 'Refunder phone number',
        address: 'Refunder address',
        Financial: 'Financial information',
        Settlement: 'Settlement method',
        labels: 'Add label',
        Associated: 'Associated documents',
        Associateds: 'Internal refund Order No.',
        Thirdparty: 'Third-party refund Order No.',
        Thirdorder: 'Customer Order No.',
        Internal: 'CSG Order No.',
        creation: 'Internal Creation Time',
        Threerefund: 'Third-party refund time',
        Refundtime: 'Refund completion time',
        Image: 'Image attachment',
        Upload: 'Upload',
        Product: 'Product Information',
        Add: 'Add refund product',
        Select: 'Select products to refund',
        Other: 'Other',
        Unshipped: 'Unshipped quantity:',
        Refunded: 'Refunded quantity:',
        Refundable: 'Available refund quantity:',
        Shipment: 'Delivery status:',
        Preemption: 'Reservation Status:',
        Sourcing: 'Sourcing status:',
        Delete: 'Delete',
        Is: 'Whether it is a gift',
        Item: 'Number of Item Lines',
        quantity: 'Refund quantity',
        unit: 'Refund unit price',
        Total: 'Total refund',
        Operation: 'Action',
        Approveed: 'Approved',
        Audit: 'Rejected',
        Cancel: 'Cancel',
        Otherr: 'Others',
        Are: 'Are you sure you want to approve this review?',
        Auditrejected: 'Reject',
        Pleasereason: 'Please enter the rejection reason',
        Pleaseenter: 'Please enter',
        Areyou: 'Are you sure you want to cancel this refund order?',
        Cancelyou: 'Cancellation reason',
        Cancellation: 'Cancellation succeeded',
        Modifybasic: 'Modify Account Information',
        Modifycustomer: 'Modify customer service Remarks',
        wantot: 'Delete this attachment?',
        wantto: 'Delete this label?',
        The: 'The available refund quantity is 0',
        Theis: 'Returned data is empty, please contact the administrator.',
        BankTitle: 'Bank information',
        BankMethod: 'Refund Method',
        BankID: 'Transaction ID',
        BankComments: 'Seller Comments',
        BankName: 'Bank Name',
        BankAccount: 'Bank Account No',
        BankBSB: 'Bank BSB No',
        LogisticsRules: 'Logistics Rules'
    }
};
